import { render, staticRenderFns } from "./ViberSignOut.vue?vue&type=template&id=2489c863&scoped=true"
import script from "./ViberSignOut.vue?vue&type=script&lang=js"
export * from "./ViberSignOut.vue?vue&type=script&lang=js"
import style0 from "./ViberSignOut.vue?vue&type=style&index=0&id=2489c863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2489c863",
  null
  
)

export default component.exports